<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDePagamentosDeContasAPagar from "./LinhaDePagamentosDeContasAPagar.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
]);

const emits = defineEmits([
    "update:alteraPagamento",
]);

//==================================================================//
//====================== Altera Pagamento ==========================//
//==================================================================//

const alteraPagamento = (update = {})=>{

    emits('update:alteraPagamento',update);

};

//==================================================================//
//============= Pagamentos de Contas a Pagar Headers ===============//
//==================================================================//

let pagamentosHeaders = [
    { text: '',                         value: 'controles'},
    { text: 'Seq do Pagamento',         value: 'sequencia'},
    { text: 'Tipo',                     value: 'tipo'},
    { text: 'Status',                   value: 'status'},
    // { text: 'Nota Fiscal Recebida',     value: 'notaFiscalRecebidaNumero'},
    { text: 'Data Criação',             value: 'dataCriacao'},
    { text: 'Data Vencimento',          value: 'dataVencimento'},
    { text: 'Valor Desconto',           value: 'valorDesconto'},
    { text: 'Valor Pagamento',          value: 'valorPagamento'},
    { text: 'Valor Reservado',          value: 'valorReservado'},
    { text: 'Valor a Pagar',            value: 'valorParaPagar'},
    { text: 'Valor Pago',               value: 'valorPago'},
    // { text: 'Valor a Vincular',         value: 'valorParaVincular'},
    // { text: 'Valor Vinculado',          value: 'valorVinculado'},
    { text: '',                         value: 'espaco'},
]

</script>

<template>

    <div class="c-table-wrapper">

        <div class="c-table">

            <div class="c-table__headers">

                <div class="c-table__header" v-for="pagamentoHeader in pagamentosHeaders"
                    :key="pagamentoHeader.value"
                >

                    <div class="c-table__header-content">

                        {{pagamentoHeader.text}}

                    </div>
                    
                </div>

            </div>
            <div class="c-table__body">

                <LinhaDePagamentosDeContasAPagar v-for="pagamento in props?.contaAPagar?.pagamentos"
                    :controlesDesativados="props?.controlesDesativados"
                    :key="pagamento.id"
                    :dado="props?.dado"
                    :contaAPagar="props?.contaAPagar"
                    :pagamento="pagamento"
                    @update:alteraPagamento="alteraPagamento"
                ></LinhaDePagamentosDeContasAPagar>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table-wrapper{
    overflow: hidden !important;
    padding: 12px 12px 12px 12px !important;
}

.c-table{
    background: #ffffff;
    display: grid;
    grid-template-columns: repeat(11,max-content) auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

.c-table__headers{
    display: contents;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-table__header{
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #dedede;
    color: #363636;
}

.c-table__body{
    display: contents;
}

</style>
